import React, { Component } from 'react';

export default class StoreLocator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stores: window.session
        };
    }

    render() {
        let storeElements = this.state.stores ? this.state.stores.map( (val, ind, arr) => {
            return (
                <div className="col-lg-3 mb-2" key={ind}>
                    <div key={ind} className='card w-100 p-1 text-center h-100'>
                        <div>
                            <h3>{val.name}</h3>
                            <p>{val.address}</p>
                            {val.address2 ? <p>{val.address2}</p> : ''}
                            <p>{val.city}, {val.state} {val.zip}</p>
                        </div>
                        <div className="card-body d-flex flex-column">
                            <button onClick={() => {document.location = val.url_path || val.urlslug }} className="btn btn-primary mt-auto">Place Order</button>
                        </div>
                    </div>
                </div>);
        }) : <p>It appears this franchise has no stores set up with online ordering</p>;
        return(
            <div className='container' id='mainDiv'>
                <h1 className='m-2'>Store Locator</h1>
                <hr />
                <div className="row">
                    {storeElements}
                </div>
            </div>
        );
    }
}